import { combineReducers } from "redux";

//COMMON SLICES
import theme from "./slices/themeSlice";
import auth from "./slices/authSlice";
import statusListSlice from "./slices/statusListSlice";
import countsSlice from "./slices/countSlice";
import statusListAllSlice from "./slices/statusListSliceAll";
import commentListSlice from "./slices/commentListSlice";
import commentCreateSlice from "./slices/commentCreateSlice";
import firebaseNotificationSlice from "./slices/firebaseNotificationSlice";
import PermissionSlice from "../store/slices/permissionSlice";
import MyDetailSlice from "../store/slices/userDetailsSlice";
import countStatusSlice from "./slices/countStatusSlice";
import userListSlice from "../views/admin-views/administration/permission/redux/usersListSlice";
import regionSlice from "../views/app-views/territory-mapping/redux/regionSlice";

//IOREL SlICES
import * as authSlices from "../views/auth-views/config/reducer";
import * as leaderboardSlices from "../views/analytics-views/dashboards/sub-dashboards/internal/leaderboard/config/reducer";
import * as orgChartSlices from "../views/app-views/org-chart/config/reducer";
import * as newsSlices from "../views/app-views/news/config/reducer";
import * as settingsSlices from "../views/app-views/settings/config/reducer";
import * as organizationSlices from "../views/app-views/organization/config/reducer";
import * as employeeSlices from "../views/app-views/employee/config/reducer";
import * as burningIssuesSlices from "../views/app-views/burning-issues/config/reducer";
import * as wfourSlices from "../views/app-views/w-four/config/reducer";
import * as complainSlices from "../views/app-views/complains/config/reducer";
import * as warrantySlices from "../views/app-views/warranty/config/reducer";
import * as dashboardSlices from "../views/app-views/dashboards/config/reducer";
import * as goalBIPSlices from "../views/app-views/goals/config/reducer";
import * as meetingSlices from "../views/app-views/meetings/config/reducer";
import * as stockTakeSlices from "../views/app-views/stock-take/config/reducer";
import * as sopSlices from "../views/app-views/sop/config/reducer";
import * as gisSetupSlices from "../views/app-views/gis/gis-settings/config/reducer";
import * as gisAnalyticsSlices from "../views/analytics-views/dashboards/sub-dashboards/internal/gis-map/config/reducer";
import * as b2cSlices from "../views/app-views/b2c/config/reducer";
import * as dealerSlices from "../views/app-views/dealer/config/reducer";
import * as productSlices from "../views/app-views/product/config/reducer";
import * as dashboardListSlice from "../views/analytics-views/dashboards/config/reducer";
import * as dashboardMGMTSlices from "../views/analytics-views/dashboards-mgmt/config/reducer";
import * as ticketIssueTypesSlices from "../views/app-views/tickets/config/reducer";
import * as permSlices from "../views/admin-views/administration/config/reducer";
import * as mealSlices from "../views/app-views/meal/config/reducer";
import * as employeeRequestsSlices from "../views/app-views/requests/employee-request/config/reducer";
import * as requestApprovalSlices from "../views/app-views/requests/request-approvals/config/reducer";
import * as tTenSlices from "../views/app-views/t-ten/config/reducer";
import * as visionSlices from "../views/app-views/vision/config/reducer";
import * as locationQRSlices from "../views/app-views/location-qr/config/reducer";
import * as attendanceSlices from "../views/app-views/attendance/config/reducer";
import * as jobDescriptionSlices from "../views/app-views/job-description/config/reducer";
import * as expensesSlices from "../views/app-views/expenses/config/reducer";
import * as lmsSlices from "../views/app-views/lms/config/reducer";
import * as territoryMappingSlices from "../views/app-views/territory-mapping/config/reducer";
import * as eventSlices from "../views/app-views/events/config/reducer";
import * as gatepassSlices from "../views/app-views/gatepass/config/reducer";
import * as pmoSlices from "../views/app-views/pmo/config/reducer";
import * as dmsSlices from "../views/app-views/dms/config/reducer";
import * as pettyCashSlices from "../views/app-views/petty-cash/config/reducer";
import * as tmsSlices from "../views/app-views/tms/config/reducer";
import * as meetupSlices from "../views/app-views/meetup/config/reducer";
import * as feedbackSlices from "../views/app-views/feedback/config/reducer";

// OREL MART SLICES
import * as orelMartSlices from "../views/reward-views/config/reducer";

//asset 
import *as assetSlices from "../views/app-views/asset-managements/config/reducer";
import * as userManagementSlices from "../views/admin-views/administration/user-management/config/reducer";

const rootReducer = (asyncReducers) => (state, action) => {
	const combinedReducer = combineReducers({
		theme,
		auth,
		MyDetailSlice,
		PermissionSlice,
		statusListSlice,
		countsSlice,
		statusListAllSlice,
		commentListSlice,
		commentCreateSlice,
		firebaseNotificationSlice,
		countStatusSlice,
		userListSlice,
		regionSlice,
		...asyncReducers,
		...authSlices,
		...leaderboardSlices,
		...orgChartSlices,
		...newsSlices,
		...settingsSlices,
		...organizationSlices,
		...employeeSlices,
		...burningIssuesSlices,
		...wfourSlices,
		...complainSlices,
		...warrantySlices,
		...dashboardSlices,
		...goalBIPSlices,
		...meetingSlices,
		...stockTakeSlices,
		...sopSlices,
		...gisSetupSlices,
		...gisAnalyticsSlices,
		...b2cSlices,
		...dealerSlices,
		...productSlices,
		...dashboardListSlice,
		...dashboardMGMTSlices,
		...permSlices,
		...ticketIssueTypesSlices,
		//OREL MART SLICE
		...orelMartSlices,
		...mealSlices,
		...employeeRequestsSlices,
		...requestApprovalSlices,
		...tTenSlices,
		...visionSlices,
		...locationQRSlices,
		...attendanceSlices,
		...jobDescriptionSlices,
		...pmoSlices,
		...dmsSlices,
		...expensesSlices,
		...lmsSlices,
		...territoryMappingSlices,
		...eventSlices,
		...gatepassSlices,
		...pettyCashSlices,
		...tmsSlices,
		...meetupSlices,
		...feedbackSlices,
		...assetSlices,
		...userManagementSlices
	});
	return combinedReducer(state, action);
};

export default rootReducer;

